import { Stack } from 'components';

import { NoteForm } from '../NoteForm';

export const AiScribeMedia = () => {
  return (
    <>
      <NoteForm.AiScribe.Status />
      <NoteForm.AiScribe.AudioPlayer />
    </>
  );
};

export const DraftActions = () => {
  return (
    <NoteForm.Actions>
      <NoteForm.Actions.Left>
        <NoteForm.DeleteButton />
      </NoteForm.Actions.Left>
      <NoteForm.Actions.Right>
        <NoteForm.AutosaveIndicator />
        <NoteForm.SubmitButton>Final</NoteForm.SubmitButton>
      </NoteForm.Actions.Right>
    </NoteForm.Actions>
  );
};

export const PopupDraftActions = ({
  onEdit,
  deleteDisabled = false,
  submitDisabled = false
}: {
  onEdit?: () => void;
  deleteDisabled?: boolean;
  submitDisabled?: boolean;
}) => {
  return (
    <NoteForm.Actions>
      <NoteForm.Actions.Left>
        <NoteForm.DeleteButton disabled={deleteDisabled} />
        <NoteForm.EditButton onClick={onEdit} />
      </NoteForm.Actions.Left>
      <NoteForm.Actions.Right>
        <NoteForm.AutosaveIndicator />
        <NoteForm.SubmitButton disabled={submitDisabled}>Final</NoteForm.SubmitButton>
      </NoteForm.Actions.Right>
    </NoteForm.Actions>
  );
};

export const FinalizedEditActions = ({ onCancel }: { onCancel?: () => void }) => {
  return (
    <NoteForm.Actions>
      <div></div>
      <NoteForm.Actions.Right>
        <Stack display="flex" gap="12px" flexDirection="row" alignItems="center">
          <Stack width="124px">
            <NoteForm.CancelButton onClick={onCancel}>Cancel</NoteForm.CancelButton>
          </Stack>
          <Stack width="124px">
            <NoteForm.SubmitButton>Final</NoteForm.SubmitButton>
          </Stack>
        </Stack>
      </NoteForm.Actions.Right>
    </NoteForm.Actions>
  );
};
